import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { Errors, validationType } from 'src/app/core/model/error.model';
import { BeneficiaryService } from 'src/app/services/beneficiary/beneficiary.service';
import { CommonService } from 'src/app/services/common/common.service';
import { FatcaService } from 'src/app/services/fatca/fatca.service';
import { OopsModalComponent } from '../oops-modal/oops-modal.component';

@Component({
  selector: 'app-subcategory',
  templateUrl: './subcategory.component.html',
  styleUrls: ['./subcategory.component.scss'],
})
export class SubcategoryComponent implements OnInit {
  subsidiary: FormGroup;
  error = Errors;
  todayDate = new Date();
  showLoader: boolean = false;
  setValueInSubject;
  exmptionCategory: any;
  constructor(
    private modalController: ModalController,
    private fatcaService: FatcaService,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    this.createForm();
    this.getMasterData();
  }

  get form() {
    return this.subsidiary.controls;
  }

  createForm() {
    this.subsidiary = new FormGroup({
      selectValue: new FormControl(''),
    });
  }

  getMasterData() {
    this.commonService
      .getMasterData(1, 'entityexemptionSubcategory')
      .subscribe((res: any) => {
        this.exmptionCategory = res.value;
      });
  }

  dismissModal() {
    this.modalController.dismiss();
  }
  submit() {
    this.fatcaService.entityExceptionCode.next(this.setValueInSubject);
    this.modalController.dismiss();
  }
  setValueInSubcategory(e) {
    this.setValueInSubject = e.value;
    this.fatcaService.entityExceptionCode.next(e.value);
  }
}
